var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7361 2.34273C16.088 2.69454 16.088 3.2489 15.7361 3.60071L13.9878 5.33844L10.6616 2.01224L12.3993 0.263857C12.7511 -0.0879523 13.3055 -0.0879523 13.6573 0.263857L15.7361 2.34273ZM0 16V12.6738L9.46684 3.20694L12.793 6.53313L3.32619 16H0Z",
    fill: "#849291"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.452c0c74d03a9b703f15ddd4421fcc82.svg";
export { ForwardRef as ReactComponent };